import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserModel, CartItemsModel } from '../../core/models/ShoppingCart.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ItemListDialogComponent } from '../item-list-dialog/item-list-dialog.component';
import { HelperService } from '../../core/services/helper.service';
import { ShoppingService } from '../../core/services/shopping.service';
import { HttpService } from '../../core/services/http.service';
import { appVariables, appApiResources } from '../../core/constants/Common.constant';
import { environment } from '../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { OrderSummaryComponent } from '../order-summary/order-summary.component';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {
  user = new UserModel();
  fromLocal: UserModel;
  Token: string;
  isUserLoggedIn:boolean;
  ShowViewAddressMode: boolean;
  paymentResponse: any;
  chargeAmount: number;
  clientTokenURL = appApiResources.getClientTokenURL;
  createPurchaseURL = appApiResources.createPurchaseURL;
  isLTI: string;
  @ViewChild(OrderSummaryComponent) orderSummaryComponent: OrderSummaryComponent;

  public IsUserLogged = new BehaviorSubject(false);
  observeIsUserLogged = this.IsUserLogged.asObservable();

  constructor(private router: Router, private route: ActivatedRoute, public dialog: MatDialog, private shoppingService: ShoppingService
    , private helperService: HelperService, private activatedRoute: ActivatedRoute, private titleService: Title) {

    this.titleService.setTitle('Checkout | F.A. Davis');
  }
  DisplaySection = appVariables.displaySectionValues;

  // openDialog() {
  //   this.dialog.open(ItemListDialogComponent, {
  //     data: {
  //       animal: 'panda'
  //     }
  //   });
  // }

  OnLogOut() {
    const AppID = this.helperService.getFromLocalStorage(appVariables.accessAppID);
    document.cookie = environment.CookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.fadavis.com; path=/;';
    this.shoppingService.logOut()
      .subscribe(
        (response) => {

        },
        (error) => { }
      );
    this.helperService.signOutUser();
    this.shoppingService.setUserDetails(new UserModel());
    this.shoppingService.setToken('');
    this.shoppingService.setAppID(AppID);
    this.shoppingService.setCartItems([]);
    this.shoppingService.setDisplaySection('LogOut');
    this.shoppingService.GetApplicationDetails();
    
    this.helperService.setToLocalStorage(appVariables.accessAppID, AppID);

    this.shoppingService.IsCheckoutComponent.emit(true);
    this.shoppingService.IsLoggedIn.emit(true);

  }
  OnChangeClick() {
    this.shoppingService.setAddressMode(false);
    this.shoppingService.setDisplaySection('ChangeAddress');

  }
  ngOnInit() {
    //document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadGoogleAnalyticScripts());
    this.activatedRoute.queryParams.subscribe(params => {
      const appID = params['appID'];
      const TokenID = params['token'];
      const GUID = params['GUID'];
      const promoCode = params['promoCode'];
      const isLTI = params['IsLTI']; 
      this.shoppingService.SetDefaultOnLoad(appID, GUID, TokenID, promoCode, isLTI);
      this.shoppingService.IsCheckoutComponent.emit(true);

      const Token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
      this.isLTI = this.helperService.getFromLocalStorage(appVariables.isLTI);
      const DisplaySection = this.helperService.getFromLocalStorage(appVariables.displaySection);
      this.shoppingService.IsLoggedIn.emit(true);
      if (Token) {
        this.IsUserLogged.next(true);
        this.shoppingService.setToken(Token);
        this.user.tokenFromUser = Token;
        this.shoppingService.logIn(this.user)
          .subscribe(
            (response) => {
              this.helperService.setUserToLocalStorage(response.Data);
              this.fromLocal = this.helperService.getUserFromLocalStorage();
              this.shoppingService.setToken(this.fromLocal['token']);
              if (this.helperService.getFromLocalStorage(appVariables.displaySection) === '') {
                this.shoppingService.setDisplaySection('Login');
              }
              document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadScript(response));
            },
            (error) => { }
          );
        if (DisplaySection) {
          this.shoppingService.setDisplaySection(DisplaySection);
        }
        this.shoppingService.GetAddress();
        this.shoppingService.GetPaymentDetails();
        this.shoppingService.loadItems();
      }

    });


    this.shoppingService.observeDisplaySection.subscribe(response => {
      this.DisplaySection = response;
    });

    this.shoppingService.observeAddressMode.subscribe(value => {
      this.ShowViewAddressMode = value;
    });

    this.shoppingService.observeToken.subscribe(response => {
      this.Token = response;
      if (this.Token === '' || this.Token === null || this.Token === undefined) {} else {
        this.fromLocal = this.helperService.getUserFromLocalStorage();

      }
    });

    this.shoppingService.loadItems();
    this.shoppingService.GetApplicationDetails();
    if (this.DisplaySection.Address && this.DisplaySection.Payment) {
      this.shoppingService.setAddressMode(false);
      this.shoppingService.setDisplaySection('ChangeAddress');
    }
  }

  onDropinLoaded(event) {
    this.chargeAmount = this.orderSummaryComponent.OrderSummary.Total;
    console.log("dropin loaded...");
  }

  onPaymentStatus(response): void {
    this.paymentResponse = response;
  }

}




// WEBPACK FOOTER //
// ./src/app/shoppingcart/checkout/checkout.component.ts